export const timeRanges = [
  { label: "1 Week", value: "7" },
  { label: "1 Month", value: "30" },
  { label: "6 Months", value: "180" },
  { label: "1 Year", value: "365" },
];
